// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from './util/request.js';
import '../static/fonts/font.css'
import VueMeta from 'vue-meta';
Vue.use(VueMeta);
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

const http = new XMLHttpRequest();
http.open('GET', './conf/app-config.json');
http.onreadystatechange = function (e) {
  if (http.readyState === 4 && http.status === 200) {
    const config = JSON.parse(http.responseText);
    if (process.env.NODE_ENV === 'production') {
      Vue.prototype.$config = config.build;
    }else {
      Vue.prototype.$config = config.dev;
    }
    // 初始化
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
}
http.send();

//路由跳转定位到首页
router.afterEach((to,from,next) => {
  document.body.scrollTop =0;
  document.documentElement.scrollTop = 0;
  
  });
// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'saveEvt') {
    // 创建一个StorageEvent事件
    let newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}


// WEBPACK FOOTER //
// ./src/main.js